<label [for]="for" class="ald-label">
    {{ label }}
</label>
